import { VFC } from 'react';
import { Modal, Row, Space } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useStore } from 'routes/inventorize_meter/useStore';
import { apolloClient } from 'services/apolloClient';
import { queryClient } from 'services/queryClient';
import { useSessionStore } from 'store/session';
import { FormattedMessage } from 'react-intl';
import { Button } from '../Button/Button';
import { useLogoutModalVisibilityStore } from './store';
import { Modal as messages } from './messages';

export const LogoutModal: VFC = () => {
  const navigate = useNavigate();
  const { setVisibility: setLogoutModalVisibility } = useLogoutModalVisibilityStore();
  const { resetAll } = useStore();

  const handleLogoutClick = () => {
    resetAll();
    setLogoutModalVisibility(false);
    useSessionStore.setState({ isAuthenticated: false, apiKey: null, email: null });
    apolloClient.clearStore().catch(console.error);
    queryClient.clear();
    navigate('/');
  };

  return (
    <Modal
      open
      footer={
        <Row wrap={false}>
          <Button block onClick={() => setLogoutModalVisibility(false)}>
            <FormattedMessage {...messages.cancel} />
          </Button>
          <Button block type="primary" onClick={handleLogoutClick}>
            <FormattedMessage {...messages.logoutAction} />
          </Button>
        </Row>
      }
      title={<FormattedMessage {...messages.logoutFromApp} />}
      onCancel={() => setLogoutModalVisibility(false)}
    >
      <Space align="center" className="w-100" direction="vertical">
        <span>
          <FormattedMessage {...messages.logoutConfirmation} />
        </span>
      </Space>
    </Modal>
  );
};
